var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWarningAlert(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_104_30798)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.5811 22.1075L16.9302 2.71913C16.3424 1.64918 15.2196 0.984375 14 0.984375C12.7805 0.984375 11.6576 1.64909 11.0697 2.71913L0.418843 22.1075C-0.807185 24.3393 0.805224 27.0703 3.34908 27.0703H24.651C27.1947 27.0703 28.8072 24.3393 27.5811 22.1075Z",
    fill: "#FF6F7F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.32857 9.70518C7.32857 9.64185 7.33035 9.57887 7.33098 9.51562L0.418009 22.1123C-0.80558 24.3419 0.803623 27.0703 3.34241 27.0703H18.2109C11.7715 23.957 7.32857 17.3512 7.32857 9.70518Z",
    fill: "#FC5C70"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.1698 20.6743L15.3806 8.25859C14.7819 7.1638 13.2181 7.1638 12.6194 8.25859L5.83016 20.6743C5.25248 21.7307 6.01225 23.0234 7.21076 23.0234H20.7892C21.9877 23.0234 22.7475 21.7307 22.1698 20.6743Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7109 20.2617C14.7109 20.6392 14.3927 20.9453 14 20.9453C13.6073 20.9453 13.2891 20.6393 13.2891 20.2617C13.2891 19.8841 13.6073 19.5781 14 19.5781C14.3926 19.5781 14.7109 19.8842 14.7109 20.2617Z",
    fill: "#423E4F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.0097 18.7405C13.6398 18.7405 13.3398 18.4406 13.3398 18.0706V12.2785C13.3398 11.9086 13.6398 11.6086 14.0097 11.6086C14.3797 11.6086 14.6796 11.9086 14.6796 12.2785V18.0706C14.6796 18.4406 14.3797 18.7405 14.0097 18.7405Z",
    fill: "#423E4F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.42544 15.9688L5.8312 20.6789C5.25047 21.7332 6.01425 23.0234 7.21909 23.0234H12.7422C10.8311 21.0326 9.3442 18.6329 8.42544 15.9688Z",
    fill: "#E0E0E0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_104_30798"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningAlert);
export default __webpack_public_path__ + "static/media/warning-alert.30cf758887234a4586d95b79546ba05e.svg";
export { ForwardRef as ReactComponent };